import PermissionDescription from './models/PermissionDescription'
import { IAMAPI } from './API'
import { collection } from 'infra/collection'
import { Observable } from 'rxjs'
import { PermissionDescriptionDTO } from './dtos/permissions'
import Member from './models/Member'
import { take } from 'rxjs/operators'

export default class PermissionStore {
  /**
   * The kinds of permissions.
   */
  permissions = collection<PermissionDescriptionDTO, PermissionDescription>({
    create: () => new PermissionDescription(),
  })

  constructor(
    private api: IAMAPI,
    currentMember$: Observable<Member>,
  ) {
    // First time we select a member, fetch permissions.
    currentMember$.pipe(take(1)).subscribe(() => this.find())
  }

  async find() {
    return this.api.permissions
      .find()
      .then((data) => this.permissions.set(data))
  }
}
